/**
  pagination handler for grid views
 */

import { UIButton, UIDiv, UISelect, UIText } from '@ui';

export function initProjectPagination(view, projectId) {
  if (!view.projectPagination.has(projectId)) {
    view.projectPagination.set(projectId, {
      currentPage: 1,
      isLoading: false,
    });
  }
  return view.projectPagination.get(projectId);
}

export function createPaginationControls(view, projectId, totalTasks) {
  const pagination = initProjectPagination(view, projectId);
  const totalPages = Math.ceil(totalTasks / view.tasksPerPage);

  if (pagination.currentPage > totalPages && totalPages > 0) {
    pagination.currentPage = totalPages;
  } else if (pagination.currentPage < 1) {
    pagination.currentPage = 1;
  }

  const controls = new UIDiv();

  controls.setClass('flex items-center justify-center p-3 gap-4 w-full');

  const taskCountSpan = new UIText(`${totalTasks} total tasks`);
  controls.add(taskCountSpan);

  const prevButton = new UIButton('Previous').setClass(
    'px-4 py-2 rounded-md bg-[var(bg-tertiary)] cursor-pointer disabled:bg-gray-300 disabled:cursor-not-allowed',
  );
  prevButton.setDisabled(pagination.currentPage <= 1);
  prevButton.onClick(() => {
    if (pagination.currentPage > 1) {
      pagination.currentPage--;
      view.refreshProjectContent(projectId);
    }
  });

  const pageSelect = new UISelect();
  const options = [];
  for (let i = 1; i <= totalPages; i++) {
    options[i] = `Page ${i}`;
  }
  pageSelect.setOptions(options, pagination.currentPage);

  pageSelect.onChange(e => {
    pagination.currentPage = parseInt(e.target.value, 10);
    view.refreshProjectContent(projectId);
  });

  const nextButton = new UIButton('Next');
  nextButton.setDisabled(pagination.currentPage >= totalPages);
  nextButton.onClick(() => {
    if (pagination.currentPage < totalPages) {
      pagination.currentPage++;
      view.refreshProjectContent(projectId);
    }
  });

  controls.add(prevButton);
  controls.add(pageSelect);
  controls.add(nextButton);

  return controls;
}
